export const colors = {
    eventcool: '#3875FE',
    pfizer: '#E60012',
    novartis: '#0099ff',
    dscl: '#00b4ed',
    ipsen: '#224a81',
    roche: '#2D82F0'
}